import theme from '../Theme/Theme';

const styles = () => ({
  spanStyle: {
    fontWeight: theme.font.weight.semibold,
  },
});

export default styles;
